import React from "react";

/**
 * Renders a customizable toggle switch.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.text - The text to display next to the toggle switch.
 * @param {boolean} props.isOn - The state of the toggle switch, true for on and false for off.
 * @param {function} props.handleToggle - The function to call when the toggle switch is clicked.
 *
 * @returns {JSX.Element} The rendered toggle switch component.
 */
const ToggleSwitch = ({ text, isOn, handleToggle }) => {
  return (
    <label className="inline-flex items-center justify-center m-auto cursor-pointer">
      <input
        type="checkbox"
        checked={isOn}
        onChange={handleToggle}
        className="sr-only peer"
      />
      <span className="relative mr-2 text-md font-medium text-gray-500">
        <p>{text}</p>
      </span>
      <div
        className="relative w-7 h-[14px] bg-gray-200 
         peer-focus:ring-blue-300 rounded-full peer
         peer-checked:after:translate-x-full 
         rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] 
         after:absolute  after:start-[2px] after:bg-primary 
         after:rounded-full after:h-[14px] after:w-[14px] 
         after:transition-all peer-checked:bg-primary-200"
      ></div>
    </label>
  );
};

export default ToggleSwitch;
